import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/LP202407/GitHubActions'

const GitHubActions: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={'GitHub Actions CI/CD パイプライン デプロイ ビルド'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/services/githubactions/'}
        title="Github Actions | サービス | Aitria（アイトリア）"
        description="GitHub Actions導入支援で、CI/CDパイプラインを自動化し、コードのビルド、テスト、デプロイを迅速化。開発からリリースまでのサイクルを大幅短縮します。"
      />
      <Template />
    </>
  )
}

export default GitHubActions
